import React from "react";
import {Box, Divider} from "@mui/material";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";

export interface SentenceResultViewProps {
    sentence: string;
    translation: string;
}

export default function SentenceResultView({sentence, translation}: SentenceResultViewProps) {

    if (!sentence) {
        return null;
    }

    return (
        <ListItemReversedTextView title="Context Sentence"
                                  content={(
                                      <Box sx={{display: "flex", alignItems: "start", justifyContent: "flex-start"}}>
                                          <Box>
                                              {sentence}
                                              <Divider/>
                                              {translation}
                                          </Box>
                                      </Box>
                                  )}/>
    );
}
